/* eslint-disable no-unused-vars */
import React, { useContext } from "react";
import Link from "next/link";
import { FormContext } from "../../../../pages/_app";
import { Image } from "react-bootstrap";
import { parseHtml, toWebp } from "../../../../utils/common";
import dynamic from "next/dynamic";

const HocButton = dynamic(() => import('../../../HigherOrderComponent/HocButton'))

let baseUrl = process.env.NEXT_PUBLIC_REACT_APP_RESOURCE_BASE_URL;

function ServiceFullBanner(props) {
	const { showForm } = useContext(FormContext);
	let block = props.block;
	let showTags = props.showTags;
	let ctaButton = block.button.length > 0 ? block.button[0] : block.button;

	return (
		<>
			<section className="agile-banner-section agile-full-banner">
				<div className="agile-banner-inner">
					<div className="container">
						<div className="row">
							<div className="col-lg-8 col-md-8  col-sm-7 col-12">
								<div className="agile-banner-content">
									<div className="heading">
										<h1 className="page-heading">
											{block.title}
										</h1>
										<h3>{block.short_title}</h3>
										{block.description
											? parseHtml(
													block.description, true
												)
											: ""}
									</div>
									<HocButton
										button={ctaButton}
										btnAction={() => showForm()}
									>
										<Link
											href={"/request-proposal"}
											className="btn btn-primary"
										>
											{ctaButton.label}
										</Link>
									</HocButton>
									{showTags && block?.tags?.length ? (
										<div className="agile-banner-notes">
											<ul>
												{block?.tags.map((tag) => (
													<li key={tag.id}>
														<p>{tag?.Title}</p>
													</li>
												))}
											</ul>
										</div>
									) : (
										<></>
									)}
								</div>
							</div>
							<div className="col-lg-4 col-md-4  col-sm-5 col-12">
								<div className="agile-banner-img">
									{block?.image_widgets.data?.[0]?.attributes
										.url ? (
										<Image
											src={toWebp(
												`${baseUrl}${block?.image_widgets.data?.[0]?.attributes.url}`
											)}
											alt={
												block?.image_widgets.data?.[0]
													?.attributes
													?.alternativeText ||
												block?.image_widgets.data?.[0]
													?.attributes?.name
											}
											width="402px" height="402px"
										/>
									) : (
										<></>
									)}
								</div>
							</div>
						</div>
					</div>
				</div>
			</section>
		</>
	);
}

export default ServiceFullBanner;
